<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="header" >
    <div class="logo-wrap">
      <a href="/video/-1">
        <img class="logo" src="@/assets/images/logo.png">
      </a>
    </div>
    <div class="header-right">
      <div class="user-info" v-if="userInfo">
        <img class="user-avatar" :src="userInfo.avatar" alt="" />
        <el-dropdown>
          <span class="user-nickName">
            {{ userInfo.nickName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="loginOut()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div> 
</template>
<script>
/*eslint-disable*/
import Config from '@/servies/config.js';
export default {
  data() {
    return {
      userInfo: null,
      pageName: '',
    }
  },
  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem('sh-userInfo'))
    console.log(this.$route)
    this.pageName = this.$route.path.split('/')[1];
  },
  methods: {
    jumpVideo () {
      this.$router.push({ path: '/video/-1' }, () => {})
    },
    async loginOut () {
      try {
        const res = await this.$axios.post(`${Config.API_ROOT}/mine/v1/logout?platform=msite&token=${this.userInfo.token}&uid=${this.userInfo.uid}`)
        if (res) {
          this.$utils.clearLoginUserCookie()
          window.location.href = '/login';
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
          setTimeout(() => {
            window.location.href = '/login';
          }, 300)
        }
      } catch (error) {
        setTimeout(() => {
          window.location.href = '/login';
        }, 300)
      }
      
    }
  }
}
</script>
<style lang="less" scoped>
.header{
  height: 64px;
  width: 100%;
  background: rgba(251, 251, 251, 0.90);
  backdrop-filter: blur(10px);
  position: fixed;
  padding: 0 60px 0 40px;
  display: flex;
  top: 0;
  z-index: 10;
  justify-content: space-between;
  align-items: center;
  .logo-wrap{
    width: 182px;
    height: 24px;
    .logo{
      display: block;
      width: 182px;
      height: 24px;
    }
  }
  .header-right{
    display: flex;
  }
  .user-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      display: inline-block;
      vertical-align: middle;
    }
    .user-nickName{
      cursor: pointer;
    }
  }
}
</style>
